export const immutableReplaceAt = <T>(
  array: T[],
  index: number,
  value: T
): T[] => Object.assign([], array, { [index]: value });
